import { render } from "./SVG.vue?vue&type=template&id=6c870467&scoped=true&ts=true"
import script from "./SVG.vue?vue&type=script&lang=ts"
export * from "./SVG.vue?vue&type=script&lang=ts"

import "./SVG.vue?vue&type=style&index=0&id=6c870467&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c870467"]])

export default __exports__